import ValueWithinConstraints from "./ValueWithinConstraints";

export const RgbHexToHsv = (rgbHex) => {
    const { r, g, b } = ParseRgbHex(rgbHex);
    return RgbToHsv(r, g, b);
}

export const RgbToHsv = (r, g, b) => {
    let rr, gg, bb, h, s;
    const rabs = r / 255;
    const gabs = g / 255;
    const babs = b / 255;
    const v = Math.max(rabs, gabs, babs);
    const diff = v - Math.min(rabs, gabs, babs);
    const diffc = c => (v - c) / 6 / diff + 1 / 2;
    const percentRoundFn = num => Math.round(num * 100) / 100;
    if (diff === 0) {
        h = s = 0;
    } else {
        s = diff / v;
        rr = diffc(rabs);
        gg = diffc(gabs);
        bb = diffc(babs);

        if (rabs === v) {
            h = bb - gg;
        } else if (gabs === v) {
            h = (1 / 3) + rr - bb;
        } else if (babs === v) {
            h = (2 / 3) + gg - rr;
        } else {
            h = 0;
        }
        if (h < 0) {
            h += 1;
        } 
        if (h > 1) {
            h -= 1;
        }
    }
    return {
        h: Math.round(h * 360),
        s: percentRoundFn(s * 100),
        v: percentRoundFn(v * 100)
    };
}
/**
 * Parses rgb hexes in form #fff or #ffffff
 * @param {string} rgbHex rgb hex in form #fff or #ffffff
 * @returns {{r: number g: number, b: number}} RGB values in 0-255 range
 */
const ParseRgbHex = (rgbHex) => {
    let r,g,b;
    if (/^#[0-9a-fA-F]{3}$/.test(rgbHex)) {
        //rgb hex is shorthand (for example #fff, #f00)
        r = ValueWithinConstraints(parseInt(rgbHex.substr(1, 1).repeat(2), 16), 0, 255);
        g = ValueWithinConstraints(parseInt(rgbHex.substr(2, 1).repeat(2), 16), 0, 255);
        b = ValueWithinConstraints(parseInt(rgbHex.substr(3, 1).repeat(2), 16), 0, 255);
    } else if (/^#[0-9a-fA-F]{6}$/.test(rgbHex)) {
        r = ValueWithinConstraints(parseInt(rgbHex.substr(1, 2), 16), 0, 255);
        g = ValueWithinConstraints(parseInt(rgbHex.substr(3, 2), 16), 0, 255);
        b = ValueWithinConstraints(parseInt(rgbHex.substr(5, 2), 16), 0, 255);
    } else {
        //if doesnt match any parsing method above, default to r=g=b=0 and therefore, h=s=v=0
        return { r: 0, g: 0, b: 0 }
    }
    return { r: r, g: g, b: b };
}